import { Info } from "lucide-react";

/**
 * Disclaimer visibile sopra le textarea dei commenti/esperienze.
 * Ricorda all'utente la responsabilità della community e la possibilità di segnalare.
 */
export function ReviewDisclaimer() {
  return (
    <div
      data-testid="review-disclaimer"
      className="mb-3 flex gap-2.5 items-start bg-[#F2EFEB] border border-[#E8E6E1] rounded-md px-3 py-2.5"
    >
      <Info size={15} className="text-[#C05C45] mt-0.5 flex-shrink-0" aria-hidden />
      <p className="font-ui text-xs text-[#5C6B64] leading-relaxed">
        Le esperienze non sono moderate a priori. Per manina non risponde del contenuto. Segnala offese o dati di
        minori: dopo verifica, rimuoveremo.
      </p>
    </div>
  );
}
